/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { ModelRefFieldDisplay } from "./display";
import { ModelRefFieldEdit } from "./edit";

const ModelRefField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <ModelRefFieldDisplay />,
        editComponent: <ModelRefFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
ModelRefField.displayName = "ModelRefField";
export { ModelRefField };
